import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MetaState {
  appName: string;
  isLoading: boolean;
  darkMode: boolean;
  notifications: {
    show: boolean;
    message: string;
    type: "success" | "error" | "info" | "warning" | null;
  };
}

const initialState: MetaState = {
  appName: "Shirohana",
  isLoading: false,
  darkMode: localStorage.getItem("darkMode") === "true",
  notifications: {
    show: false,
    message: "",
    type: null,
  },
};

export const metaSlice = createSlice({
  name: "meta",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem("darkMode", state.darkMode.toString());
    },
    showNotification: (
      state,
      action: PayloadAction<{
        message: string;
        type: "success" | "error" | "info" | "warning";
      }>
    ) => {
      state.notifications = {
        show: true,
        message: action.payload.message,
        type: action.payload.type,
      };
    },
    hideNotification: (state) => {
      state.notifications.show = false;
    },
  },
});

export const {
  setLoading,
  toggleDarkMode,
  showNotification,
  hideNotification,
} = metaSlice.actions;

// Selectors
export const selectMeta = (state: { meta: MetaState }) => state.meta;
export const selectIsLoading = (state: { meta: MetaState }) =>
  state.meta.isLoading;
export const selectDarkMode = (state: { meta: MetaState }) =>
  state.meta.darkMode;
export const selectNotifications = (state: { meta: MetaState }) =>
  state.meta.notifications;

export default metaSlice.reducer;
